import React from 'react'

// Placeholder shown in place of a list table while its first page is being
// fetched, so the page does not flash the "no records" empty state or an
// empty grid. Mirrors the shape of the real table: a title row, a header
// row and a handful of body rows with varying cell widths.
const TableSkeleton = ({ rows = 8, columns = 8, showHeader = true }) => {
  // Deterministic width variation so the grid reads as data, not bars.
  const widths = ['70%', '55%', '45%', '80%', '40%', '60%', '35%', '50%']

  return (
    <div className='table-skeleton' aria-busy='true' aria-live='polite'>
      {showHeader && (
        <div className='table-skeleton-title'>
          <span className='table-skeleton-cell table-skeleton-shine' style={{ width: 180, height: 28 }} />
          <span className='table-skeleton-cell table-skeleton-shine' style={{ width: 140, height: 40 }} />
        </div>
      )}
      <div className='table-skeleton-header'>
        {Array.from({ length: columns }).map((_, c) => (
          <span key={`h-${c}`} className='table-skeleton-col'>
            <span className='table-skeleton-cell table-skeleton-shine' style={{ width: widths[c % widths.length], height: 14 }} />
          </span>
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={`r-${r}`} className='table-skeleton-row'>
          {Array.from({ length: columns }).map((_, c) => (
            <span key={`c-${r}-${c}`} className='table-skeleton-col'>
              <span
                className='table-skeleton-cell table-skeleton-shine'
                style={{ width: widths[(r + c) % widths.length], height: 16 }}
              />
            </span>
          ))}
        </div>
      ))}
    </div>
  )
}

export default TableSkeleton
